import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { getCompanyTabs } from '@components/company-tabs/utils/getCompanyTabs';
import { Tab } from '@components/tabs/src/tabs.type';
import {
  ENABLED_COMPANY_INFO_ROUTE,
  ENABLED_COMPANY_WIDGET_ROUTE,
  ENABLED_USERS_ROUTE,
} from '@constants/company-auth-permissions';
import { useIsProtectedElement } from '@hooks/use-is-protected-element';

export const useCompanyTabs = (): { tabs: Tab[] } => {
  const { t } = useTranslation();
  const { companyId, clubSlug } = useParams<{ companyId: string; clubSlug: string }>();

  const isEnabledCompanyInfo = useIsProtectedElement({
    permissions: ENABLED_COMPANY_INFO_ROUTE,
    checkEveryPermission: false,
  });
  const isEnabledUsers = useIsProtectedElement({ permissions: ENABLED_USERS_ROUTE });
  const hasWidgetPermission = useIsProtectedElement({ permissions: ENABLED_COMPANY_WIDGET_ROUTE });

  const tabs = getCompanyTabs({
    companyId: companyId as string,
    clubSlug: clubSlug as string,
    isEnabledCompanyInfo,
    isEnabledUsers,
    isEnabledWidget: hasWidgetPermission,
    t,
  });

  return { tabs };
};
